import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage, IonRouterOutlet,loadingController } from '@ionic/vue';
import { time, calendar, card, logoWhatsapp, exitOutline } from 'ionicons/icons';
import { UserServices } from '@/services/UserServices';
import { currentUserStore } from '@/stores/currentUser';
import useAuth from "@/composables/useAuth";
import tools from "@/composables/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabsPage',
  setup(__props) {

const preLoad_misCreditos = async ()=>{
  showLoading('Cargando transacciones...');
  UserServices.reloadTransactions()
  await tools().delay(2000)
  loadingController.dismiss()
  return null
}    

const preLoad_misReservas = async ()=>{
  showLoading('Cargando reservas...');
  UserServices.reloadReservations()
  await tools().delay(2000)
  loadingController.dismiss()
  return null
}    

const preLoad_Reservar = async ()=>{
  return null
  //   await ReservationServices.getDeportes()
}

const asistencia = ()=>{
  window.open('whatsapp://send?phone=+34' + process.env.VUE_APP_WHATSAPP_ASISTENCIA + '&text=' + encodeURI('Tengo problemas con la aplicación de reserva de pistas. ¿Puedes ayudarme?'))
}

const showLoading = async (msj:string) => {
        const loading = await loadingController.create({
          message: msj,
        });
        loading.present();
      }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonTabs), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet)),
          _createVNode(_unref(IonTabBar), { slot: "bottom" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTabButton), {
                tab: "select_deporte",
                href: "/tabs/select_deporte",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (preLoad_Reservar()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(time) }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Reservar")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                tab: "mis_reservas",
                href: "/tabs/mis_reservas",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (preLoad_misReservas()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(calendar) }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Mis reservas")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                tab: "mis_creditos",
                href: "/tabs/mis_creditos",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (preLoad_misCreditos()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(card) }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Mis créditos")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                href: "/",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (asistencia()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(logoWhatsapp) }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Asistencia")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonLabel), { style: {"text-align":"center","font-size":"small","font-weight":"bold"} }, {
            default: _withCtx(() => [
              _createTextVNode(" Hola, " + _toDisplayString(_unref(currentUserStore)().user.name) + " ", 1),
              _createVNode(_unref(IonIcon), {
                icon: _unref(exitOutline),
                onClick: _cache[4] || (_cache[4] = ($event: any) => {_unref(useAuth)().logout();}),
                href: "login"
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})